import axios from "axios"
import {useState} from "react"
import {useGoogleReCaptcha} from "react-google-recaptcha-v3";
import appConfig from "../service/config"
import getErrorMessage from "../service/getError";
import Spinner from "./Spinner";

const LostPW = props => {
  const [responseMessage, setResponseMessage] = useState('')
  const [emailed, setEmailed] = useState(false)
  const [loading, setLoading] = useState(false)
  const {executeRecaptcha} = useGoogleReCaptcha();

  const onSubmit = async e => {
    e.preventDefault()
    if (!executeRecaptcha) {
      setResponseMessage('Recaptcha has not been loaded. Please try later.')
      return
    }
    setLoading(true)
    const reCaptchaToken = await executeRecaptcha('submit')
    try {
      const response = await axios.post(appConfig.api_base + 'tipsters/gett/', {
        "email": e.target.elements.email.value,
        "g-recaptcha-response": reCaptchaToken
      })
      await ajaxUserRegistration(response.data)
      setResponseMessage('')
      setEmailed(true)
      setLoading(false)
    } catch (error) {
      window.dispatchEvent(appConfig.showMessage(getErrorMessage(error)));
      setResponseMessage(getErrorMessage(error))
      setLoading(false)
    }
  }

  const ajaxUserRegistration = async data => {
    console.log(data)
    const formData = new FormData()
    formData.append('action', 'mtwprrp')
    formData.append('email', data.email)
    formData.append('t', data.t)

    const response = await axios.post(appConfig.ajax_url, formData)
    console.log(response)
  }

  return (
    <>
      {emailed &&
        <div className="alert alert-success alert-dismissible fade show">
          <h2>Reset password</h2>
          Please check your email and set your new password.
        </div>
      }
      {!emailed &&
        <form className="mtr-form" onSubmit={onSubmit}>
          <h2>Reset password</h2>
          <div className="mb-3">
            <label htmlFor="email" className="form-label">Email</label>
            <input type="email" className="form-control" id="email" name="email" required/>
          </div>
          <button type="submit" className="btn btn-primary" disabled={loading}>
            Submit<Spinner loading={loading}/>
          </button>
          {responseMessage && <div className="text-danger">{responseMessage}</div>}
        </form>
      }
    </>
  )
};

export default LostPW
